import { Box, Button, Theme, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import React from "react";

export interface IAvatarSettingsProps {
  startSession: () => void;
}

const AvatarSettings: React.FC<IAvatarSettingsProps> = ({ startSession }) => {
  const theme = useTheme<Theme>();

  function showNoAccessParameters() {
    return (
      <>
        <Typography
          component="h2"
          sx={{
            fontSize: { xs: 18, sm: 25 },
            fontWeight: 600,
            color: "#111827",
            mb: 3
          }}
        >
          {t("chatbot.common.start_chatting_with_avatar_")}
        </Typography>
      </>
    );
  }

  return (
    <Box
      component="section"
      sx={{
        width: 580,
        p: 4,
        backgroundColor: "white",
        borderRadius: 2,
        boxShadow: "0px 4px 16px rgba(0,0,0,0.05)",
        mx: "auto"
      }}
    >
      {showNoAccessParameters()}

      <Button
        fullWidth
        variant="contained"
        onClick={startSession}
        sx={{
          py: 1.5,
          borderRadius: 2.5,
          textTransform: "none",
          fontSize: { xs: 12, sm: 16 },
          fontWeight: 600,
          backgroundColor: "primary.main",
          "&:hover": {
            backgroundColor: theme.palette.customColors.core
          }
        }}
      >
        {t("chatbot.common.start_session", "Iniciar sesión")}
      </Button>
    </Box>
  );
};

export default AvatarSettings;
